import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MenuItem } from 'primeng/api';

@Component({
    selector: 'app-breadcrumb',
    imports: [
    BreadcrumbModule,
    RouterModule
],
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {
  private _items: MenuItem[] = [];
  private _home?: MenuItem;
  
  processedItems: MenuItem[] = [];
  processedHome?: MenuItem;
  
  @Input() 
  set items(value: MenuItem[]) {
    this._items = value;
    this.processedItems = value.map(item => ({
      ...item,
      routerLink: item.url || item['link'] || item.routerLink
    }));
  }
  
  get items(): MenuItem[] {
    return this._items;
  }
  
  @Input() 
  set home(value: MenuItem | undefined) {
    this._home = value;
    this.processedHome = value && (value.url || value['link']) 
      ? { ...value, routerLink: value.url || value['link'] || value.routerLink }
      : value;
  }
  
  get home(): MenuItem | undefined {
    return this._home;
  }
} 